import React from 'react';
import {StyleSheet, View, TouchableWithoutFeedback} from 'react-native';

import {IconName, SVGIcon} from '../../components';

type HeaderRightIconName = Extract<
  IconName,
  'trash' | 'download-down' | 'search-white-80' | 'share' | 'share-white',
>;

interface HeaderIconRightProps {
  onClick?: () => void;
  iconName?: HeaderRightIconName;
  iconSize?: number;
  noicon?: boolean;
}

const HeaderIconRight = (props: HeaderIconRightProps) => {
  return (
    <View style={mobileStyles.iconsContainer}>
      <TouchableWithoutFeedback onPress={props.onClick}>
        <View style={mobileStyles.iconContainer}>
          {
            !props.noicon && (
              props.iconName ? (
                <SVGIcon name={props.iconName} size={props.iconSize ?? 20} />
              ) : (
                <SVGIcon name="trash" size={20} />
              )
            )
          }

        </View>
      </TouchableWithoutFeedback>
    </View>
  );
};

export default HeaderIconRight;

const mobileStyles = StyleSheet.create({
  iconsContainer: {
    flexDirection: 'row',
    paddingHorizontal: 12,
  },
  iconContainer: {
    paddingHorizontal: 8,
  },
});
